export default "__VITE_ASSET__VIbcHzZb__"